export const LAUNCH_MODE_FULL_ACCESS = "full_access";
export const LAUNCH_MODE_TEMA_ONLY = "tema_only";

export function isAccountStatusActive(status) {
  const normalized = String(status || "active").trim().toLowerCase();
  return normalized === "active" || normalized === "1" || normalized === "approved";
}

/** Teacher may use TutorCloud portal features and return from TEMA. */
export function canReturnToTutorCloud({ launchMode, dashboardUrl, accountStatus } = {}) {
  if (launchMode === LAUNCH_MODE_TEMA_ONLY) {
    return false;
  }
  if (!isAccountStatusActive(accountStatus)) {
    return false;
  }
  return Boolean(String(dashboardUrl || "").trim());
}

/** @deprecated Prefer isTutorCloudSubscriber; dashboard always shows a hero variant. */
export function shouldShowDashboardHero() {
  return true;
}

export function isTutorCloudSubscriber({
  launchMode,
  dashboardUrl,
  accountStatus,
} = {}) {
  return canReturnToTutorCloud({ launchMode, dashboardUrl, accountStatus });
}

/** Show TutorCloud upsell hero when the teacher cannot return to TutorCloud. */
export function shouldShowTutorCloudUpsell({
  launchMode,
  dashboardUrl,
  accountStatus,
} = {}) {
  return !canReturnToTutorCloud({ launchMode, dashboardUrl, accountStatus });
}
